export const I18N_COPY = {
  "english": {
    "vote.title.default": "Vote",
    "vote.meta.participants": "{count} people participated",
    "vote.meta.maxSelect": "(Max select {max} items)",
    "vote.meta.loginHint": " · Participate in voting after logging in",
    "vote.meta.clickHint": " · Click to participate",
    "vote.meta.placeholderHint": "Participate in voting after logging in · Click to participate",
    "vote.voted.hint": "You have participated in the vote",
    "vote.modal.cancel": "Cancel",
    "vote.modal.submit": "Submit vote",
    "vote.modal.submitting": "Submitting...",
    "vote.login.prefix": "Please ",
    "vote.login.link": "Log in",
    "vote.login.suffix": " first",
    "vote.error.selectOne": "Please select at least one option",
    "vote.error.singleOnly": "Single-choice voting allows only one option",
    "vote.error.invalidData": "Vote data is invalid, please refresh and try again",
    "vote.error.submit": "Submission failed, please try again",
    "comment.error.maxImages": "You can only upload up to 9 images",
    "comment.error.uploadImages": "Failed to upload images",
    "comment.error.empty": "Please enter comment content",
    "comment.error.submit": "Failed to submit comment",
    "comment.error.submitRetry": "Failed to submit comment, please try again",
    "comment.error.cancelLike": "Failed to cancel like",
    "comment.error.like": "Failed to like",
    "comment.error.toggleLike": "Failed to toggle comment thumb, please try again",
    "comment.reply.action": "Reply",
    "comment.loading": "Loading...",
    "comment.detail.title": "Comment Detail",
    "comment.header.writeReview": "+ Write a review",
    "comment.list.title": "Comments ({count})",
    "comment.tab.hot": "Hot",
    "comment.tab.latest": "Latest",
    "comment.replies.title": "Replies ({count})",
    "comment.replies.viewMore": "View more",
    "comment.replies.load": "Load replies",
    "comment.replies.empty": "Be the first to reply.",
    "comment.list.empty": "-- No comments --",
    "comment.modal.replyTitle": "reply @{username}",
    "comment.modal.replyPrefix": "reply @",
    "comment.modal.writeTitle": "Write a review",
    "comment.modal.ratingTitle": "Rating (Free Choice)",
    "comment.editor.replyPlaceholder": "reply @{username}...",
    "comment.editor.placeholder": "Share your thoughts...",
    "comment.media.uploadHint": "Tap to add upload media files",
    "comment.submit.submitting": "Submitting...",
    "comment.submit.reply": "Submit reply",
    "comment.submit.comment": "Submit",
    "login.warn.phoneRequired": "Please enter the phone number",
    "login.warn.emailRequired": "Please enter the email",
    "login.warn.getCodeFirst": "Please get the verification code",
    "login.warn.codeRequired": "Please enter the verification code",
    "login.warn.vkNotConfigured": "VK app is not configured. Please set REACT_APP_VK_APP_ID in .env",
    "login.success.codeSent": "Verification code sent successfully",
    "login.success.login": "Login successful",
    "login.confirm.register": "No account found for this number/email. Create a new account?",
    "login.confirm.restore": "This account was deactivated. Restore and continue?",
    "login.confirm.title.register": "Create account",
    "login.confirm.title.restore": "Restore account",
    "login.confirm.yes": "Confirm",
    "login.confirm.cancel": "Cancel",
    "login.error.sendCode": "Failed to send verification code, please try again later",
    "login.error.login": "Login failed, please try again later",
    "login.info.loadingAgreement": "Loading agreement content, please wait",
    "login.warn.agreementMissing": "No agreement content found",
    "login.title": "Welcome Back",
    "login.subtitle": "Continue Login",
    "login.tab.phone": "Phone",
    "login.tab.email": "Email",
    "login.label.phone": "Phone",
    "login.label.email": "Email",
    "login.placeholder.phone": "Enter your phone number",
    "login.placeholder.email": "Enter your email",
    "login.placeholder.captcha": "Enter Captcha",
    "login.button.sending": "Sending...",
    "login.button.getCaptcha": "Get Captcha",
    "login.agreement.prefix": "By logging in, you agree to our ",
    "login.agreement.user": "User Agreement",
    "login.agreement.and": " and ",
    "login.agreement.privacy": "Privacy Agreement",
    "login.button.signingIn": "Signing in...",
    "login.button.login": "Login",
    "login.divider.orContinue": "Or continue with",
    "login.button.vk": "Continue with VK",
    "game.detail.title": "GAME DETAIL",
    "game.button.download": "Download",
    "game.button.reserve": "GET",
    "game.desc.more": "More",
    "game.desc.less": "Less",
    "game.ratings.title": "Ratings & Reviews",
    "game.ratings.count": "{count} Ratings",
    "game.bottom.tip": "That's everything for now. Start a new game?",
    "game.search.placeholder": "Games, Topics and Collections",
    "game.menu.editProfile": "Edit personal information",
    "game.menu.logout": "Log out",
    "game.right.related": "Related Games",
    "game.right.about": "About the Game",
    "game.about.provider": "Provider",
    "game.about.followers": "Followers",
    "game.about.downloads": "Downloads",
    "game.about.releaseDate": "Release date",
    "game.app.comingSoon": "The APP is under active development...",
    "game.qr.title": "Download App",
    "game.qr.subtitle": "Games worth discovering",
    "game.login.prefix": "Please ",
    "game.login.link": "Log in",
    "game.login.suffix": " first",
    "game.modal.scan": "Scan to download with",
    "game.modal.downloadTitle": "Download",
    "game.modal.verified": "Verified by Gamee",
    "collection.loading": "Loading...",
    "collection.back": "Back to Collection",
    "collection.title.default": "Collection Detail",
    "collection.hero.subtitle": "Collection • {count} Games",
    "collection.hero.description.default": "One of the most beloved fantasy RPG series of all time, spanning multiple installments and spin-offs across various platforms.",
    "collection.stat.comments": "Comments",
    "collection.stat.followers": "Followers",
    "collection.stat.releaseTime": "Release Time",
    "collection.games.title": "{count} Games in Collection",
    "collection.games.expand": "Expand games",
    "collection.games.collapse": "Collapse games",
    "collection.games.downloads": "{count} downloads",
    "collection.games.intro.default": "come and join us",
    "profile.error.fetch": "Failed to fetch user profile",
    "profile.warn.selectImage": "Please select an image file",
    "profile.success.avatarUpdated": "Avatar updated",
    "profile.error.avatarLink": "Failed to get avatar link",
    "profile.error.avatarMissingId": "Upload successful but no attachment ID returned",
    "profile.error.avatarUpload": "Failed to upload avatar",
    "profile.success.save": "Save successful",
    "profile.error.save": "Save failed",
    "profile.title": "Edit profile",
    "profile.subtitle": "Update your information",
    "profile.loading": "loading...",
    "profile.avatar.uploading": "Uploading...",
    "profile.avatar.change": "Change avatar",
    "profile.avatar.clickUpload": "Click to upload",
    "profile.label.nickname": "Nickname",
    "profile.label.country": "Country",
    "profile.label.introduction": "Introduction",
    "profile.button.cancel": "Cancel",
    "profile.button.save": "Save",
    "profile.button.saving": "Saving...",
    "profile.country.select": "Select country",
    "vk.error.auth": "VK authorization failed",
    "vk.error.noCode": "Authorization code not received",
    "vk.success.login": "VK login successful",
    "vk.confirm.register": "No VK account found. Create a new account?",
    "vk.confirm.restore": "This VK account was deactivated. Restore and continue?",
    "vk.error.invalidResponse": "Invalid login response",
    "vk.error.login": "VK login failed",
    "vk.status.loading": "Completing VK login...",
    "vk.status.success": "Login successful, redirecting...",
    "vk.status.error": "Login failed, returning to homepage...",
    "common.loading": "Loading...",
    "sidebar.language": "Language",
    "sidebar.appearance": "Appearance",
    "sidebar.theme.dark": "Dark Theme",
    "sidebar.theme.light": "Light Theme",
    "sidebar.loginCta": "Join for free or log in",
    "sidebar.footer.links": "Developer · Legal · Terms · Privacy",
    "sidebar.footer.slogan": "Hop in.",
    "home.search.placeholder": "Games, Topics and Collections",
    "home.search.mobilePlaceholder": "Search",
    "home.search.searching": "Searching...",
    "home.search.action": "Search",
    "home.app.comingSoon": "The APP is in full swing of development...",
    "home.downloadApp": "Download App",
    "home.downloadApp.loading": "Downloading...",
    "home.download.failed": "Failed to get download link, please try again later",
    "home.download.title": "Downloading Gamee App",
    "home.download.preparing": "Preparing download...",
    "home.download.downloading": "Downloading...",
    "home.download.downloadingPercent": "Downloading {percent}%...",
    "home.download.hint": "Please wait. The file will be saved as {filename}.",
    "home.download.minimize": "Minimize",
    "home.download.expand": "Show download progress",
    "home.menu.editProfile": "Edit personal information",
    "home.menu.logout": "Log out",
    "home.loginCta": "Join for free or log in",
    "home.notifications.title": "Message Center",
    "home.notifications.system": "System Notification",
    "home.notifications.empty": "No messages",
    "home.featured.title": "Featured Games",
    "home.category.default": "Category",
    "home.category.description": "Explore the top {title} games for Android on Gamee. Download free, virus-free games, read reviews, and share your own experiences.",
    "home.trending.title": "Trending Games",
    "home.trending.discussion": "Join the discussion on Gamee",
    "home.trending.defaultTopComment": "Trending in Android Popular Chart.",
    "home.trending.loadError": "Couldn't load trending games. Check your connection and try again.",
    "home.trending.empty": "No games to show here yet.",
    "home.trending.noMore": "no more games",
    "home.mobile.trending": "Trending",
    "home.search.type.games": "Games",
    "home.search.type.topics": "Topics",
    "home.search.type.collections": "Collections",
    "home.rank.top": "TOP",
    "topic.error.removeLike": "Failed to remove like",
    "topic.error.like": "Failed to like",
    "topic.error.action": "Action failed, please try again",
    "topic.warn.maxImages": "You can upload at most 9 images",
    "topic.error.imageUpload": "Image upload failed",
    "topic.warn.titleRequired": "Please enter a title",
    "topic.warn.contentOrImage": "Please enter content or add at least one image",
    "topic.warn.waitImages": "Please wait for images to finish uploading",
    "topic.warn.pollQuestion": "Please enter a poll question",
    "topic.warn.pollOptions": "Please enter at least two poll options",
    "topic.error.createPoll": "Failed to create poll",
    "topic.error.pollNoId": "Poll created but server did not return a vote id",
    "topic.success.postCreated": "Post created successfully",
    "topic.error.createPostRetry": "Failed to create post, please try again later",
    "topic.warn.deleteOwnOnly": "You can only delete your own posts",
    "topic.success.postDeleted": "Post deleted",
    "topic.error.deletePostRetry": "Failed to delete post, please try again later",
    "topic.back": "Back to Topic",
    "topic.hero.collapse": "Collapse",
    "topic.hero.expand": "Expand",
    "topic.hero.replies": "{count} replies · Enter thread discussion",
    "topic.hero.enterDiscussion": "Enter thread discussion",
    "topic.posts.title": "Post List",
    "topic.posts.count": "{count} posts",
    "topic.posts.create": "Create Post",
    "topic.posts.loading": "Loading posts...",
    "topic.posts.empty": "No posts yet",
    "topic.posts.deleting": "Deleting...",
    "topic.posts.delete": "Delete",
    "topic.posts.loadingMore": "Loading more posts...",
    "topic.posts.scrollLoadMore": "Scroll to bottom to load more",
    "topic.posts.noMore": "No more posts",
    "topic.modal.createTitle": "Create Post",
    "topic.modal.titlePlaceholder": "Please enter post title",
    "topic.modal.contentPlaceholder": "Please enter post content (optional if you add images)",
    "topic.modal.uploading": "Uploading…",
    "topic.modal.addImages": "Add images (max 9, 2MB each)",
    "topic.modal.addPoll": "Add poll",
    "topic.modal.cancel": "Cancel",
    "topic.modal.publishing": "Publishing...",
    "topic.modal.publish": "Publish",
    "topic.delete.title": "Delete post",
    "topic.delete.confirm": "Are you sure you want to delete this post? This cannot be undone.",
    "topic.side.moderator": "Moderator",
    "topic.side.moderatorEmpty": "No moderator information available",
    "topic.side.activeUsers": "Active users",
    "topic.side.activeUsersEmpty": "No active users",
    "topic.poll.single": "Single",
    "topic.poll.multiple": "Multiple",
    "topic.poll.choiceType": "Choice type",
    "topic.poll.maxChoices": "Max choices",
    "topic.poll.optionsLabel": "Options (2–8)",
    "topic.poll.optionPlaceholder": "Option {index}",
    "topic.poll.addOption": "+ Add option",
    "topics.title": "Topics",
    "topics.subtitle": "Discover what players are discussing",
    "topics.voted": "{count} people voted",
    "topics.empty": "No topics",
    "collections.title": "Collections",
    "collections.subtitle": "Discover more selected collections",
    "collections.noMore": "No more collections",
    "navbar.loginCta": "Join for Free or Login",
    "postDetail.back": "Back",
    "postDetail.loading": "loading...",
    "postDetail.notFound": "Post not found or deleted",
    "postDetail.untitled": "Untitled Post",
    "postDetail.unknownUser": "Unknown User",
    "postDetail.unknownTime": "Unknown Time",
    "postDetail.likes": "{count} likes",
    "postDetail.comments": "{count} comments",
    "postDetail.noDescription": "No description",
    "notFound.title": "{path} is not available!",
    "notFound.message": "The page you tried to access is not available. You will be redirected to our browse section shortly. If you think this is an error,",
    "notFound.contact": "contact us!",
    "browse.title": "Trending and Topic",
    "browse.subtitle": "Based on player counts and ratings",
    "browse.filterBy": "Filter by:",
    "browse.clearFilter": "Clear Filter",
    "footer.privacy": "Privacy",
    "footer.security": "Security",
    "footer.cookies": "Cookies",
    "footer.legal": "Legal",
    "footer.guidelines": "Collaborative Guidelines",
    "footer.about": "About",
    "cart.add": "Add to cart",
    "cart.added": "Added",
    "filters.title": "Filters",
    "filters.wishlist": "Wishlist",
    "filters.ratings": "Ratings",
    "filters.reviews": "Reviews",
    "filters.genres": "Genres",
    "filters.genre.action": "Action",
    "filters.genre.strategy": "Strategy",
    "filters.genre.rpg": "RPG",
    "filters.genre.shooter": "Shooter",
    "filters.genre.adventure": "Adventure",
    "filters.genre.puzzle": "Puzzle",
    "filters.genre.racing": "Racing",
    "filters.genre.sports": "Sports",
    "grid.noReviews.title": "There are no reviews yet!",
    "grid.noReviews.subtitle": "You can add some, soon.",
    "legacyGamePage.about": "About",
    "legacyGamePage.none": "No",
    "legacyGamePage.website": "Website",
    "legacyGamePage.released": "Released",
    "legacyGamePage.platforms": "Platforms",
    "legacyGamePage.mainGenre": "Main Genre",
    "legacyGamePage.developers": "Developers",
    "legacyGamePage.publishers": "Publishers",
    "legacyGamePage.hide": "Hide",
    "legacyGamePage.more": "More",
    "legacyGamePage.notAvailable": "Not available",
    "backTop.aria": "Back to Top",
    "aria.menu": "Menu",
    "aria.back": "Back",
    "aria.extend": "Extend",
    "aria.like": "Like",
    "aria.add": "Add",
    "aria.zoomPreview": "Click to zoom preview",
    "aria.prevScreenshot": "Previous screenshot",
    "aria.nextScreenshot": "Next screenshot",
    "aria.userMenu": "User menu",
    "aria.user": "User",
    "aria.logIn": "Log in",
    "aria.prevImage": "Previous image",
    "aria.nextImage": "Next image",
    "aria.closePreview": "Close preview",
    "aria.closeMenu": "Close menu",
    "aria.facebook": "Facebook",
    "aria.discord": "Discord",
    "aria.twitter": "Twitter",
    "aria.youtube": "Youtube",
    "aria.reddit": "Reddit",
    "aria.search": "Search",
    "aria.notifications": "Notifications",
    "aria.platform": "Platform",
    "aria.android": "Android",
    "aria.preview": "Preview",
    "aria.close": "Close",
    "aria.reply": "Reply",
    "aria.prevOne": "previous one",
    "aria.nextOne": "next one",
    "vote.aria.participate": "participate in voting",
    "comment.aria.backToComments": "Back to comments",
    "comment.aria.deleteImage": "Delete image",
    "comment.aria.addImage": "Add image",
    "topic.aria.quickActions": "Post quick actions",
    "topic.aria.viewComments": "View comments",
    "topic.aria.sidebar": "Topic sidebar",
    "topic.aria.verifiedModerator": "Verified moderator",
    "topic.aria.previewImage": "Preview image",
    "topic.aria.removeImage": "Remove image",
    "topic.aria.addImages": "Add images",
    "topic.aria.removeOption": "Remove option",
    "profile.aria.uploadAvatar": "Upload avatar",
    "login.aria.countryCode": "Country code",
    "login.aria.verificationCode": "Verification code",
    "login.aria.closeAgreement": "Close agreement",
    "home.search.type.aria": "Search Type (Games, Topics, Collections)",
    "browse.aria.currentFilter": "Current Filter",
    "browse.aria.clearFilters": "Clear Filters",
    "postDetail.aria.poll": "Post poll",
    "slider.aria.prevPicture": "Previous Picture",
    "slider.aria.nextPicture": "Next Picture",
    "slider.aria.jumpToPicture": "Jump to picture",
    "filters.aria.openWishlist": "Open wishlist",
    "filters.aria.sortRatings": "Sort after ratings",
    "filters.aria.sortReviews": "Sort after reviews",
    "filters.aria.genreAction": "Show action genre",
    "filters.aria.genreStrategy": "Show Strategy genre",
    "filters.aria.genreRpg": "Show RPG genre",
    "filters.aria.genreShooter": "Show Shooter genre",
    "filters.aria.genreAdventure": "Show Adventure genre",
    "filters.aria.genrePuzzle": "Show Puzzle genre",
    "filters.aria.genreRacing": "Show Racing genre",
    "filters.aria.genreSports": "Show Sports genre",
    "login.error.network": "Network error, please check your connection and try again",
    "login.error.sendCodeTimeout": "Sending verification code timed out, please try again",
    "login.error.sendCodeException": "Sending verification code failed due to a request error, please try again later",
    "login.error.loginTimeout": "Login request timed out, please try again",
    "login.error.loginException": "Login failed due to a request error, please try again later",
    "request.error.timeout": "Request timed out, please try again",
    "request.error.network": "Network error, please check your connection and try again",
    "request.error.serverException": "Server is busy, please try again later",
    "request.error.requestException": "Request failed, please try again later",
    "request.error.sessionExpired": "Session expired, please log in again",
    "home.search.noResult": "No results found",
    "home.search.selectFromList": "Found multiple results, please choose one from the list",
    "comment.poll.questionRequired": "Please enter a poll question",
    "comment.poll.optionsRequired": "Please enter at least two poll options",
    "comment.poll.maxSelectedRange": "Max selections must be between 2 and {count}",
    "comment.poll.addPoll": "Add poll",
    "comment.poll.questionPlaceholder": "Please enter a poll question",
    "comment.poll.choiceType": "Choice type",
    "comment.poll.single": "Single",
    "comment.poll.multiple": "Multiple",
    "comment.poll.maxChoices": "Max choices",
    "comment.poll.optionsLabel": "Options (2–8)",
    "comment.poll.optionPlaceholder": "Option {index}",
    "comment.poll.addOption": "+ Add option"
  },
  "russian": {
    "vote.title.default": "Голосование",
    "vote.meta.participants": "Участвовало: {count}",
    "vote.meta.maxSelect": "(Можно выбрать до {max})",
    "vote.meta.loginHint": " · Войдите, чтобы проголосовать",
    "vote.meta.clickHint": " · Нажмите, чтобы проголосовать",
    "vote.meta.placeholderHint": "Войдите, чтобы проголосовать · Нажмите для участия",
    "vote.voted.hint": "Вы уже проголосовали",
    "vote.modal.cancel": "Отмена",
    "vote.modal.submit": "Отправить голос",
    "vote.modal.submitting": "Отправка...",
    "vote.login.prefix": "Пожалуйста, ",
    "vote.login.link": "войдите",
    "vote.login.suffix": "",
    "vote.error.selectOne": "Выберите хотя бы один вариант",
    "vote.error.singleOnly": "Для одиночного выбора доступен только один вариант",
    "vote.error.invalidData": "Некорректные данные голосования, обновите страницу и попробуйте снова",
    "vote.error.submit": "Не удалось отправить голос, попробуйте снова",
    "comment.error.maxImages": "Можно загрузить не более 9 изображений",
    "comment.error.uploadImages": "Не удалось загрузить изображения",
    "comment.error.empty": "Введите текст комментария",
    "comment.loading": "Загрузка...",
    "comment.reply.action": "Ответ",
    "comment.replies.viewMore": "Показать еще",
    "comment.replies.load": "Загрузить ответы",
    "comment.submit.submitting": "Отправка...",
    "comment.submit.reply": "Отправить ответ",
    "comment.submit.comment": "Отправить",
    "login.title": "С возвращением",
    "login.subtitle": "Продолжить вход",
    "login.tab.phone": "Телефон",
    "login.tab.email": "Email",
    "login.button.login": "Войти",
    "login.divider.orContinue": "Или продолжить через",
    "login.button.vk": "Войти через VK",
    "game.button.download": "Скачать",
    "game.button.reserve": "Предрегистрация",
    "game.desc.more": "Еще",
    "game.desc.less": "Скрыть",
    "game.ratings.title": "Оценки и отзывы",
    "game.right.related": "Похожие игры",
    "game.right.about": "Об игре",
    "game.login.prefix": "Пожалуйста, ",
    "game.login.link": "войдите",
    "game.login.suffix": "",
    "comment.error.submit": "Failed to submit comment",
    "comment.error.submitRetry": "Failed to submit comment, please try again",
    "comment.error.cancelLike": "Failed to cancel like",
    "comment.error.like": "Failed to like",
    "comment.error.toggleLike": "Failed to toggle comment thumb, please try again",
    "comment.detail.title": "Comment Detail",
    "comment.header.writeReview": "+ Write a review",
    "comment.list.title": "Comments ({count})",
    "comment.tab.hot": "Hot",
    "comment.tab.latest": "Latest",
    "comment.replies.title": "Replies ({count})",
    "comment.replies.empty": "Be the first to reply.",
    "comment.list.empty": "-- No comments --",
    "comment.modal.replyTitle": "reply @{username}",
    "comment.modal.replyPrefix": "Ответ @",
    "comment.modal.writeTitle": "Write a review",
    "comment.modal.ratingTitle": "Rating (Free Choice)",
    "comment.editor.replyPlaceholder": "reply @{username}...",
    "comment.editor.placeholder": "Share your thoughts...",
    "comment.media.uploadHint": "Tap to add upload media files",
    "login.warn.phoneRequired": "Please enter the phone number",
    "login.warn.emailRequired": "Please enter the email",
    "login.warn.getCodeFirst": "Please get the verification code",
    "login.warn.codeRequired": "Please enter the verification code",
    "login.warn.vkNotConfigured": "VK app is not configured. Please set REACT_APP_VK_APP_ID in .env",
    "login.success.codeSent": "Verification code sent successfully",
    "login.success.login": "Login successful",
    "login.confirm.register": "No account found for this number/email. Create a new account?",
    "login.confirm.restore": "This account was deactivated. Restore and continue?",
    "login.confirm.title.register": "Create account",
    "login.confirm.title.restore": "Restore account",
    "login.confirm.yes": "Confirm",
    "login.confirm.cancel": "Cancel",
    "login.error.sendCode": "Failed to send verification code, please try again later",
    "login.error.login": "Login failed, please try again later",
    "login.info.loadingAgreement": "Loading agreement content, please wait",
    "login.warn.agreementMissing": "No agreement content found",
    "login.label.phone": "Phone",
    "login.label.email": "Email",
    "login.placeholder.phone": "Enter your phone number",
    "login.placeholder.email": "Enter your email",
    "login.placeholder.captcha": "Enter Captcha",
    "login.button.sending": "Sending...",
    "login.button.getCaptcha": "Get Captcha",
    "login.agreement.prefix": "By logging in, you agree to our ",
    "login.agreement.user": "User Agreement",
    "login.agreement.and": " and ",
    "login.agreement.privacy": "Privacy Agreement",
    "login.button.signingIn": "Signing in...",
    "game.detail.title": "GAME DETAIL",
    "game.ratings.count": "{count} Ratings",
    "game.bottom.tip": "That's everything for now. Start a new game?",
    "game.search.placeholder": "Games, Topics and Collections",
    "game.menu.editProfile": "Edit personal information",
    "game.menu.logout": "Log out",
    "game.about.provider": "Provider",
    "game.about.followers": "Followers",
    "game.about.downloads": "Downloads",
    "game.about.releaseDate": "Release date",
    "game.app.comingSoon": "The APP is under active development...",
    "game.qr.title": "Download App",
    "game.qr.subtitle": "Games worth discovering",
    "game.modal.scan": "Scan to download with",
    "game.modal.downloadTitle": "Download",
    "game.modal.verified": "Verified by Gamee",
    "collection.loading": "Loading...",
    "collection.back": "Back to Collection",
    "collection.title.default": "Collection Detail",
    "collection.hero.subtitle": "Collection • {count} Games",
    "collection.hero.description.default": "One of the most beloved fantasy RPG series of all time, spanning multiple installments and spin-offs across various platforms.",
    "collection.stat.comments": "Comments",
    "collection.stat.followers": "Followers",
    "collection.stat.releaseTime": "Release Time",
    "collection.games.title": "{count} Games in Collection",
    "collection.games.expand": "Expand games",
    "collection.games.collapse": "Collapse games",
    "collection.games.downloads": "{count} downloads",
    "collection.games.intro.default": "come and join us",
    "profile.error.fetch": "Failed to fetch user profile",
    "profile.warn.selectImage": "Please select an image file",
    "profile.success.avatarUpdated": "Avatar updated",
    "profile.error.avatarLink": "Failed to get avatar link",
    "profile.error.avatarMissingId": "Upload successful but no attachment ID returned",
    "profile.error.avatarUpload": "Failed to upload avatar",
    "profile.success.save": "Save successful",
    "profile.error.save": "Save failed",
    "profile.title": "Edit profile",
    "profile.subtitle": "Update your information",
    "profile.loading": "loading...",
    "profile.avatar.uploading": "Uploading...",
    "profile.avatar.change": "Change avatar",
    "profile.avatar.clickUpload": "Click to upload",
    "profile.label.nickname": "Nickname",
    "profile.label.country": "Country",
    "profile.label.introduction": "Introduction",
    "profile.button.cancel": "Cancel",
    "profile.button.save": "Save",
    "profile.button.saving": "Saving...",
    "profile.country.select": "Select country",
    "vk.error.auth": "VK authorization failed",
    "vk.error.noCode": "Authorization code not received",
    "vk.success.login": "VK login successful",
    "vk.confirm.register": "No VK account found. Create a new account?",
    "vk.confirm.restore": "This VK account was deactivated. Restore and continue?",
    "vk.error.invalidResponse": "Invalid login response",
    "vk.error.login": "VK login failed",
    "vk.status.loading": "Completing VK login...",
    "vk.status.success": "Login successful, redirecting...",
    "vk.status.error": "Login failed, returning to homepage...",
    "common.loading": "Загрузка...",
    "sidebar.language": "Язык",
    "sidebar.appearance": "Оформление",
    "sidebar.theme.dark": "Темная тема",
    "sidebar.theme.light": "Светлая тема",
    "sidebar.loginCta": "Присоединиться бесплатно или войти",
    "sidebar.footer.links": "Разработчикам · Правовая информация · Условия · Конфиденциальность",
    "sidebar.footer.slogan": "Присоединяйся.",
    "home.search.placeholder": "Игры, темы и коллекции",
    "home.search.mobilePlaceholder": "Поиск",
    "home.search.searching": "Поиск...",
    "home.search.action": "Найти",
    "home.app.comingSoon": "Приложение активно разрабатывается...",
    "home.downloadApp": "Скачать приложение",
    "home.downloadApp.loading": "Загрузка...",
    "home.download.failed": "Не удалось получить ссылку для скачивания, попробуйте позже",
    "home.download.title": "Загрузка приложения Gamee",
    "home.download.preparing": "Подготовка загрузки...",
    "home.download.downloading": "Загрузка...",
    "home.download.downloadingPercent": "Загрузка {percent}%...",
    "home.download.hint": "Пожалуйста, подождите. Файл будет сохранён как {filename}.",
    "home.download.minimize": "Свернуть",
    "home.download.expand": "Показать прогресс загрузки",
    "home.menu.editProfile": "Редактировать профиль",
    "home.menu.logout": "Выйти",
    "home.loginCta": "Присоединиться бесплатно или войти",
    "home.notifications.title": "Центр сообщений",
    "home.notifications.system": "Системное уведомление",
    "home.notifications.empty": "Сообщений нет",
    "home.featured.title": "Рекомендуемые игры",
    "home.category.default": "Категория",
    "home.category.description": "Изучайте лучшие {title} игры для Android на Gamee. Скачивайте бесплатные и безопасные игры, читайте отзывы и делитесь своим опытом.",
    "home.trending.title": "Популярные игры",
    "home.trending.discussion": "Присоединяйтесь к обсуждению на Gamee",
    "home.trending.defaultTopComment": "В тренде в чарте популярных игр Android.",
    "home.trending.loadError": "Не удалось загрузить популярные игры. Проверьте сеть и попробуйте снова.",
    "home.trending.empty": "Пока нет игр для отображения.",
    "home.trending.noMore": "больше игр нет",
    "home.mobile.trending": "В тренде",
    "home.search.type.games": "Игры",
    "home.search.type.topics": "Темы",
    "home.search.type.collections": "Коллекции",
    "home.rank.top": "ТОП",
    "topic.error.removeLike": "Не удалось убрать лайк",
    "topic.error.like": "Не удалось поставить лайк",
    "topic.error.action": "Действие не выполнено, попробуйте снова",
    "topic.warn.maxImages": "Можно загрузить не более 9 изображений",
    "topic.error.imageUpload": "Не удалось загрузить изображение",
    "topic.warn.titleRequired": "Введите заголовок",
    "topic.warn.contentOrImage": "Введите текст или добавьте хотя бы одно изображение",
    "topic.warn.waitImages": "Дождитесь завершения загрузки изображений",
    "topic.warn.pollQuestion": "Введите вопрос опроса",
    "topic.warn.pollOptions": "Добавьте минимум два варианта опроса",
    "topic.error.createPoll": "Не удалось создать опрос",
    "topic.error.pollNoId": "Опрос создан, но сервер не вернул ID голосования",
    "topic.success.postCreated": "Пост успешно создан",
    "topic.error.createPostRetry": "Не удалось создать пост, попробуйте позже",
    "topic.warn.deleteOwnOnly": "Можно удалять только свои посты",
    "topic.success.postDeleted": "Пост удален",
    "topic.error.deletePostRetry": "Не удалось удалить пост, попробуйте позже",
    "topic.back": "Назад к теме",
    "topic.hero.collapse": "Свернуть",
    "topic.hero.expand": "Развернуть",
    "topic.hero.replies": "{count} ответов · Перейти к обсуждению",
    "topic.hero.enterDiscussion": "Перейти к обсуждению",
    "topic.posts.title": "Список постов",
    "topic.posts.count": "{count} постов",
    "topic.posts.create": "Создать пост",
    "topic.posts.loading": "Загрузка постов...",
    "topic.posts.empty": "Постов пока нет",
    "topic.posts.deleting": "Удаление...",
    "topic.posts.delete": "Удалить",
    "topic.posts.loadingMore": "Загрузка дополнительных постов...",
    "topic.posts.scrollLoadMore": "Прокрутите вниз, чтобы загрузить еще",
    "topic.posts.noMore": "Больше постов нет",
    "topic.modal.createTitle": "Создать пост",
    "topic.modal.titlePlaceholder": "Введите заголовок поста",
    "topic.modal.contentPlaceholder": "Введите содержимое поста (необязательно, если добавлены изображения)",
    "topic.modal.uploading": "Загрузка…",
    "topic.modal.addImages": "Добавить изображения (макс. 9, до 2 МБ каждое)",
    "topic.modal.addPoll": "Добавить опрос",
    "topic.modal.cancel": "Отмена",
    "topic.modal.publishing": "Публикация...",
    "topic.modal.publish": "Опубликовать",
    "topic.delete.title": "Удалить пост",
    "topic.delete.confirm": "Вы уверены, что хотите удалить этот пост? Это действие нельзя отменить.",
    "topic.side.moderator": "Модератор",
    "topic.side.moderatorEmpty": "Информация о модераторах недоступна",
    "topic.side.activeUsers": "Активные пользователи",
    "topic.side.activeUsersEmpty": "Нет активных пользователей",
    "topic.poll.single": "Одиночный выбор",
    "topic.poll.multiple": "Множественный выбор",
    "topic.poll.choiceType": "Тип выбора",
    "topic.poll.maxChoices": "Макс. выборов",
    "topic.poll.optionsLabel": "Варианты (2–8)",
    "topic.poll.optionPlaceholder": "Вариант {index}",
    "topic.poll.addOption": "+ Добавить вариант",
    "topics.title": "Темы",
    "topics.subtitle": "Узнайте, что обсуждают игроки",
    "topics.voted": "Проголосовали: {count}",
    "topics.empty": "Тем нет",
    "collections.title": "Коллекции",
    "collections.subtitle": "Откройте больше отобранных коллекций",
    "collections.noMore": "Больше коллекций нет",
    "navbar.loginCta": "Присоединиться бесплатно или войти",
    "postDetail.back": "Назад",
    "postDetail.loading": "загрузка...",
    "postDetail.notFound": "Пост не найден или удален",
    "postDetail.untitled": "Пост без названия",
    "postDetail.unknownUser": "Неизвестный пользователь",
    "postDetail.unknownTime": "Неизвестное время",
    "postDetail.likes": "{count} лайков",
    "postDetail.comments": "{count} комментариев",
    "postDetail.noDescription": "Нет описания",
    "notFound.title": "{path} недоступна!",
    "notFound.message": "Страница, к которой вы пытались получить доступ, недоступна. Скоро вы будете перенаправлены в раздел обзора. Если вы считаете это ошибкой,",
    "notFound.contact": "свяжитесь с нами!",
    "browse.title": "Тренды и темы",
    "browse.subtitle": "На основе количества игроков и оценок",
    "browse.filterBy": "Фильтр по:",
    "browse.clearFilter": "Очистить фильтр",
    "footer.privacy": "Конфиденциальность",
    "footer.security": "Безопасность",
    "footer.cookies": "Cookies",
    "footer.legal": "Правовая информация",
    "footer.guidelines": "Правила сообщества",
    "footer.about": "О нас",
    "cart.add": "В корзину",
    "cart.added": "Добавлено",
    "filters.title": "Фильтры",
    "filters.wishlist": "Избранное",
    "filters.ratings": "Рейтинг",
    "filters.reviews": "Отзывы",
    "filters.genres": "Жанры",
    "filters.genre.action": "Экшен",
    "filters.genre.strategy": "Стратегия",
    "filters.genre.rpg": "RPG",
    "filters.genre.shooter": "Шутер",
    "filters.genre.adventure": "Приключения",
    "filters.genre.puzzle": "Головоломка",
    "filters.genre.racing": "Гонки",
    "filters.genre.sports": "Спорт",
    "grid.noReviews.title": "Отзывов пока нет!",
    "grid.noReviews.subtitle": "Вы можете добавить их позже.",
    "legacyGamePage.about": "Об игре",
    "legacyGamePage.none": "Нет",
    "legacyGamePage.website": "Сайт",
    "legacyGamePage.released": "Релиз",
    "legacyGamePage.platforms": "Платформы",
    "legacyGamePage.mainGenre": "Основной жанр",
    "legacyGamePage.developers": "Разработчики",
    "legacyGamePage.publishers": "Издатели",
    "legacyGamePage.hide": "Скрыть",
    "legacyGamePage.more": "Еще",
    "legacyGamePage.notAvailable": "Недоступно",
    "backTop.aria": "Наверх",
    "aria.menu": "Меню",
    "aria.back": "Назад",
    "aria.extend": "Развернуть",
    "aria.like": "Лайк",
    "aria.add": "Добавить",
    "aria.zoomPreview": "Нажмите для увеличения",
    "aria.prevScreenshot": "Предыдущий скриншот",
    "aria.nextScreenshot": "Следующий скриншот",
    "aria.userMenu": "Меню пользователя",
    "aria.user": "Пользователь",
    "aria.logIn": "Войти",
    "aria.prevImage": "Предыдущее изображение",
    "aria.nextImage": "Следующее изображение",
    "aria.closePreview": "Закрыть предпросмотр",
    "aria.closeMenu": "Закрыть меню",
    "aria.facebook": "Facebook",
    "aria.discord": "Discord",
    "aria.twitter": "Twitter",
    "aria.youtube": "Youtube",
    "aria.reddit": "Reddit",
    "aria.search": "Поиск",
    "aria.notifications": "Уведомления",
    "aria.platform": "Платформа",
    "aria.android": "Android",
    "aria.preview": "Предпросмотр",
    "aria.close": "Закрыть",
    "aria.reply": "Ответить",
    "aria.prevOne": "предыдущее",
    "aria.nextOne": "следующее",
    "vote.aria.participate": "участвовать в голосовании",
    "comment.aria.backToComments": "Назад к комментариям",
    "comment.aria.deleteImage": "Удалить изображение",
    "comment.aria.addImage": "Добавить изображение",
    "topic.aria.quickActions": "Быстрые действия поста",
    "topic.aria.viewComments": "Просмотреть комментарии",
    "topic.aria.sidebar": "Боковая панель темы",
    "topic.aria.verifiedModerator": "Проверенный модератор",
    "topic.aria.previewImage": "Предпросмотр изображения",
    "topic.aria.removeImage": "Удалить изображение",
    "topic.aria.addImages": "Добавить изображения",
    "topic.aria.removeOption": "Удалить вариант",
    "profile.aria.uploadAvatar": "Загрузить аватар",
    "login.aria.countryCode": "Код страны",
    "login.aria.verificationCode": "Код подтверждения",
    "login.aria.closeAgreement": "Закрыть соглашение",
    "home.search.type.aria": "Тип поиска (Игры, Темы, Коллекции)",
    "browse.aria.currentFilter": "Текущий фильтр",
    "browse.aria.clearFilters": "Очистить фильтры",
    "postDetail.aria.poll": "Опрос поста",
    "slider.aria.prevPicture": "Предыдущее изображение",
    "slider.aria.nextPicture": "Следующее изображение",
    "slider.aria.jumpToPicture": "Перейти к изображению",
    "filters.aria.openWishlist": "Открыть избранное",
    "filters.aria.sortRatings": "Сортировать по рейтингу",
    "filters.aria.sortReviews": "Сортировать по отзывам",
    "filters.aria.genreAction": "Показать жанр Экшен",
    "filters.aria.genreStrategy": "Показать жанр Стратегия",
    "filters.aria.genreRpg": "Показать жанр RPG",
    "filters.aria.genreShooter": "Показать жанр Шутер",
    "filters.aria.genreAdventure": "Показать жанр Приключения",
    "filters.aria.genrePuzzle": "Показать жанр Головоломка",
    "filters.aria.genreRacing": "Показать жанр Гонки",
    "filters.aria.genreSports": "Показать жанр Спорт",
    "login.error.network": "Ошибка сети, проверьте подключение и попробуйте снова",
    "login.error.sendCodeTimeout": "Время отправки кода истекло, попробуйте снова",
    "login.error.sendCodeException": "Не удалось отправить код из-за ошибки запроса, попробуйте позже",
    "login.error.loginTimeout": "Время запроса входа истекло, попробуйте снова",
    "login.error.loginException": "Вход не выполнен из-за ошибки запроса, попробуйте позже",
    "request.error.timeout": "Время запроса истекло, попробуйте снова",
    "request.error.network": "Ошибка сети, проверьте подключение и попробуйте снова",
    "request.error.serverException": "Сервер перегружен, попробуйте позже",
    "request.error.requestException": "Запрос не выполнен, попробуйте позже",
    "request.error.sessionExpired": "Сессия истекла, войдите снова",
    "home.search.noResult": "Ничего не найдено",
    "home.search.selectFromList": "Найдено несколько результатов, выберите один из списка",
    "comment.poll.questionRequired": "Введите вопрос для опроса",
    "comment.poll.optionsRequired": "Введите как минимум два варианта",
    "comment.poll.maxSelectedRange": "Макс. выборов должно быть от 2 до {count}",
    "comment.poll.addPoll": "Добавить опрос",
    "comment.poll.questionPlaceholder": "Введите вопрос для опроса",
    "comment.poll.choiceType": "Тип выбора",
    "comment.poll.single": "Одиночный выбор",
    "comment.poll.multiple": "Множественный выбор",
    "comment.poll.maxChoices": "Макс. выборов",
    "comment.poll.optionsLabel": "Варианты (2–8)",
    "comment.poll.optionPlaceholder": "Вариант {index}",
    "comment.poll.addOption": "+ Добавить вариант"
  },
  "chinese_simplified": {
    "vote.title.default": "投票",
    "vote.meta.participants": "{count} 位小伙伴已参与",
    "vote.meta.maxSelect": "（最多选择 {max} 项）",
    "vote.meta.loginHint": " · 登录后可参与投票",
    "vote.meta.clickHint": " · 点我参与",
    "vote.meta.placeholderHint": "登录后就能参与投票 · 点我参与",
    "vote.voted.hint": "你已经参与过这次投票啦",
    "vote.modal.cancel": "取消",
    "vote.modal.submit": "提交投票",
    "vote.modal.submitting": "提交中...",
    "vote.login.prefix": "请先",
    "vote.login.link": "登录",
    "vote.login.suffix": "",
    "vote.error.selectOne": "请至少选择一项",
    "vote.error.singleOnly": "单选投票仅允许选择一项",
    "vote.error.invalidData": "投票信息有点异常，刷新后再试试吧",
    "vote.error.submit": "提交失败了，稍后再试试",
    "comment.error.maxImages": "最多上传 9 张图片哦",
    "comment.error.uploadImages": "图片上传失败了，再试一次吧",
    "comment.error.empty": "写点内容再发吧",
    "comment.loading": "加载中...",
    "comment.reply.action": "回复",
    "comment.replies.viewMore": "查看更多",
    "comment.replies.load": "加载回复",
    "comment.submit.submitting": "提交中...",
    "comment.submit.reply": "提交回复",
    "comment.submit.comment": "提交",
    "login.title": "欢迎回来",
    "login.subtitle": "继续登录",
    "login.tab.phone": "手机",
    "login.tab.email": "邮箱",
    "login.button.login": "登录",
    "login.divider.orContinue": "或使用以下方式继续",
    "login.button.vk": "使用 VK 登录",
    "game.button.download": "下载",
    "game.button.reserve": "预注册",
    "game.desc.more": "更多",
    "game.desc.less": "收起",
    "game.ratings.title": "评分与评论",
    "game.right.related": "相关游戏",
    "game.right.about": "关于游戏",
    "game.login.prefix": "请先",
    "game.login.link": "登录",
    "game.login.suffix": "",
    "comment.error.submit": "发布评论失败了",
    "comment.error.submitRetry": "发布评论失败了，稍后再试试",
    "comment.error.cancelLike": "取消点赞失败了",
    "comment.error.like": "点赞失败了",
    "comment.error.toggleLike": "操作失败了，再试试吧",
    "comment.detail.title": "评论详情",
    "comment.header.writeReview": "+ 写条评论",
    "comment.list.title": "评论（{count}）",
    "comment.tab.hot": "热门",
    "comment.tab.latest": "最新",
    "comment.replies.title": "回复（{count}）",
    "comment.replies.empty": "来做第一个回复的人吧",
    "comment.list.empty": "还没有评论，快来抢沙发",
    "comment.modal.replyTitle": "回复 @{username}",
    "comment.modal.replyPrefix": "回复 @",
    "comment.modal.writeTitle": "写条评论",
    "comment.modal.ratingTitle": "评分（可选）",
    "comment.editor.replyPlaceholder": "回复 @{username}...",
    "comment.editor.placeholder": "分享一下你的想法吧...",
    "comment.media.uploadHint": "点这里添加图片",
    "login.warn.phoneRequired": "先填写手机号吧",
    "login.warn.emailRequired": "先填写邮箱吧",
    "login.warn.getCodeFirst": "先获取验证码哦",
    "login.warn.codeRequired": "请输入验证码",
    "login.warn.vkNotConfigured": "VK 还没配置好，请先在 .env 里设置 REACT_APP_VK_APP_ID",
    "login.success.codeSent": "验证码已发送，注意查收",
    "login.success.login": "登录成功，欢迎回来",
    "login.confirm.register": "未找到该手机/邮箱账号，是否注册新账号？",
    "login.confirm.restore": "该账号已注销，是否恢复并继续登录？",
    "login.confirm.title.register": "注册账号",
    "login.confirm.title.restore": "恢复账号",
    "login.confirm.yes": "确认",
    "login.confirm.cancel": "取消",
    "login.error.sendCode": "验证码发送失败了，稍后再试试",
    "login.error.login": "登录失败了，稍后再试试",
    "login.info.loadingAgreement": "协议内容加载中，请稍等",
    "login.warn.agreementMissing": "暂时没有可用的协议内容",
    "login.label.phone": "手机号",
    "login.label.email": "邮箱",
    "login.placeholder.phone": "请输入手机号",
    "login.placeholder.email": "请输入邮箱",
    "login.placeholder.captcha": "请输入验证码",
    "login.button.sending": "发送中...",
    "login.button.getCaptcha": "获取验证码",
    "login.agreement.prefix": "登录即表示你同意我们的",
    "login.agreement.user": "用户协议",
    "login.agreement.and": " 和 ",
    "login.agreement.privacy": "隐私协议",
    "login.button.signingIn": "登录中...",
    "game.detail.title": "游戏详情",
    "game.ratings.count": "{count} 条评分",
    "game.bottom.tip": "先看到这里啦，去发现下一款好游戏吧",
    "game.search.placeholder": "搜游戏、话题、合集",
    "game.menu.editProfile": "编辑个人资料",
    "game.menu.logout": "退出登录",
    "game.about.provider": "厂商",
    "game.about.followers": "关注数",
    "game.about.downloads": "下载量",
    "game.about.releaseDate": "发布时间",
    "game.app.comingSoon": "App 正在努力开发中，敬请期待",
    "game.qr.title": "下载 App",
    "game.qr.subtitle": "发现值得玩的好游戏",
    "game.modal.scan": "扫码即可下载",
    "game.modal.downloadTitle": "下载",
    "game.modal.verified": "由 Gamee 官方认证",
    "collection.loading": "加载中...",
    "collection.back": "返回合集",
    "collection.title.default": "合集详情",
    "collection.hero.subtitle": "合集 · {count} 款游戏",
    "collection.hero.description.default": "经典奇幻 RPG 系列合集，包含多个正传与衍生作品，跨平台都能玩。",
    "collection.stat.comments": "评论数",
    "collection.stat.followers": "关注数",
    "collection.stat.releaseTime": "发布时间",
    "collection.games.title": "合集内游戏（{count}）",
    "collection.games.expand": "展开游戏列表",
    "collection.games.collapse": "收起游戏列表",
    "collection.games.downloads": "{count} 次下载",
    "collection.games.intro.default": "快来一起玩吧",
    "profile.error.fetch": "获取个人信息失败了",
    "profile.warn.selectImage": "请选择图片文件",
    "profile.success.avatarUpdated": "头像更新成功",
    "profile.error.avatarLink": "头像链接获取失败",
    "profile.error.avatarMissingId": "上传成功了，但没拿到附件 ID",
    "profile.error.avatarUpload": "头像上传失败了",
    "profile.success.save": "保存成功",
    "profile.error.save": "保存失败了",
    "profile.title": "编辑资料",
    "profile.subtitle": "更新一下你的个人信息",
    "profile.loading": "加载中...",
    "profile.avatar.uploading": "上传中...",
    "profile.avatar.change": "更换头像",
    "profile.avatar.clickUpload": "点我上传",
    "profile.label.nickname": "昵称",
    "profile.label.country": "国家/地区",
    "profile.label.introduction": "个人简介",
    "profile.button.cancel": "取消",
    "profile.button.save": "保存",
    "profile.button.saving": "保存中...",
    "profile.country.select": "请选择国家/地区",
    "vk.error.auth": "VK 授权失败了",
    "vk.error.noCode": "没有拿到授权码",
    "vk.success.login": "VK 登录成功",
    "vk.confirm.register": "未找到 VK 账号，是否注册新账号？",
    "vk.confirm.restore": "该 VK 账号已注销，是否恢复并继续登录？",
    "vk.error.invalidResponse": "登录返回结果异常",
    "vk.error.login": "VK 登录失败了",
    "vk.status.loading": "正在完成 VK 登录...",
    "vk.status.success": "登录成功，马上跳转...",
    "vk.status.error": "登录失败，正在返回首页...",
    "common.loading": "加载中...",
    "sidebar.language": "语言",
    "sidebar.appearance": "外观",
    "sidebar.theme.dark": "深色主题",
    "sidebar.theme.light": "浅色主题",
    "sidebar.loginCta": "免费加入或登录",
    "sidebar.footer.links": "开发者 · 法律 · 条款 · 隐私",
    "sidebar.footer.slogan": "来一起玩。",
    "home.search.placeholder": "搜游戏、话题、合集",
    "home.search.mobilePlaceholder": "搜索",
    "home.search.searching": "正在搜索...",
    "home.search.action": "搜索",
    "home.app.comingSoon": "App 正在火速开发中，敬请期待",
    "home.downloadApp": "下载 App",
    "home.downloadApp.loading": "下载中...",
    "home.download.failed": "获取下载链接失败，请稍后重试",
    "home.download.title": "正在下载 Gamee App",
    "home.download.preparing": "正在准备下载...",
    "home.download.downloading": "正在下载...",
    "home.download.downloadingPercent": "正在下载 {percent}%...",
    "home.download.hint": "请稍候，文件将保存为 {filename}",
    "home.download.minimize": "最小化",
    "home.download.expand": "查看下载进度",
    "home.menu.editProfile": "编辑个人信息",
    "home.menu.logout": "退出登录",
    "home.loginCta": "免费加入或登录",
    "home.notifications.title": "消息中心",
    "home.notifications.system": "系统通知",
    "home.notifications.empty": "暂无消息",
    "home.featured.title": "本周精选",
    "home.category.default": "分类",
    "home.category.description": "来 Gamee 逛逛热门 {title} 游戏，Android可能玩。免费、安全、可看评价，还能分享你的体验。",
    "home.trending.title": "大家都在玩",
    "home.trending.discussion": "来 Gamee 一起聊聊",
    "home.trending.defaultTopComment": "正在 Android 热门榜上升中。",
    "home.trending.loadError": "热门游戏加载失败，请检查网络后重试。",
    "home.trending.empty": "这里暂时没有可展示的游戏。",
    "home.trending.noMore": "没有更多游戏了",
    "home.mobile.trending": "热榜",
    "home.search.type.games": "游戏",
    "home.search.type.topics": "话题",
    "home.search.type.collections": "合集",
    "home.rank.top": "TOP",
    "topic.error.removeLike": "取消点赞失败",
    "topic.error.like": "点赞失败",
    "topic.error.action": "操作失败，请重试",
    "topic.warn.maxImages": "最多可上传 9 张图片",
    "topic.error.imageUpload": "图片上传失败",
    "topic.warn.titleRequired": "请输入标题",
    "topic.warn.contentOrImage": "请输入内容或至少添加一张图片",
    "topic.warn.waitImages": "请等待图片上传完成",
    "topic.warn.pollQuestion": "请输入投票问题",
    "topic.warn.pollOptions": "请至少填写两个投票选项",
    "topic.error.createPoll": "创建投票失败",
    "topic.error.pollNoId": "投票已创建，但服务端未返回投票 ID",
    "topic.success.postCreated": "发布成功，大家都能看到啦",
    "topic.error.createPostRetry": "发布帖子失败，请稍后重试",
    "topic.warn.deleteOwnOnly": "只能删除自己的帖子",
    "topic.success.postDeleted": "帖子已删除",
    "topic.error.deletePostRetry": "删除帖子失败，请稍后重试",
    "topic.back": "返回话题",
    "topic.hero.collapse": "收起",
    "topic.hero.expand": "展开",
    "topic.hero.replies": "{count} 条回复 · 进入讨论串",
    "topic.hero.enterDiscussion": "进入讨论",
    "topic.posts.title": "帖子列表",
    "topic.posts.count": "{count} 篇帖子",
    "topic.posts.create": "发帖",
    "topic.posts.loading": "正在加载帖子...",
    "topic.posts.empty": "还没有帖子，来发第一条吧",
    "topic.posts.deleting": "删除中...",
    "topic.posts.delete": "删除",
    "topic.posts.loadingMore": "正在加载更多帖子...",
    "topic.posts.scrollLoadMore": "滚动到底部加载更多",
    "topic.posts.noMore": "没有更多帖子了",
    "topic.modal.createTitle": "发布帖子",
    "topic.modal.titlePlaceholder": "请输入帖子标题",
    "topic.modal.contentPlaceholder": "请输入帖子内容（如添加图片可选填）",
    "topic.modal.uploading": "上传中…",
    "topic.modal.addImages": "添加图片（最多9张，每张不超过2MB）",
    "topic.modal.addPoll": "添加投票",
    "topic.modal.cancel": "取消",
    "topic.modal.publishing": "发布中...",
    "topic.modal.publish": "立即发布",
    "topic.delete.title": "删除帖子",
    "topic.delete.confirm": "确定要删除该帖子吗？此操作不可撤销。",
    "topic.side.moderator": "版主",
    "topic.side.moderatorEmpty": "暂无版主信息",
    "topic.side.activeUsers": "活跃用户",
    "topic.side.activeUsersEmpty": "暂无活跃用户",
    "topic.poll.single": "单选",
    "topic.poll.multiple": "多选",
    "topic.poll.choiceType": "选择类型",
    "topic.poll.maxChoices": "最多可选",
    "topic.poll.optionsLabel": "选项（2–8）",
    "topic.poll.optionPlaceholder": "选项 {index}",
    "topic.poll.addOption": "+ 添加选项",
    "topics.title": "话题",
    "topics.subtitle": "看看大家最近在聊什么",
    "topics.voted": "已有 {count} 人投票",
    "topics.empty": "暂无话题",
    "collections.title": "合集",
    "collections.subtitle": "发现更多有意思的精选合集",
    "collections.noMore": "没有更多合集了",
    "navbar.loginCta": "免费加入 / 登录",
    "postDetail.back": "返回",
    "postDetail.loading": "加载中...",
    "postDetail.notFound": "帖子不存在或已被删除",
    "postDetail.untitled": "无标题帖子",
    "postDetail.unknownUser": "未知用户",
    "postDetail.unknownTime": "未知时间",
    "postDetail.likes": "{count} 个赞",
    "postDetail.comments": "{count} 条评论",
    "postDetail.noDescription": "暂无描述",
    "notFound.title": "{path} 暂不可用！",
    "notFound.message": "你访问的页面当前不可用。我们将很快带你回到浏览页。如果你觉得这是个错误，",
    "notFound.contact": "联系我们！",
    "browse.title": "趋势与话题",
    "browse.subtitle": "基于玩家数量和评分",
    "browse.filterBy": "筛选：",
    "browse.clearFilter": "清除筛选",
    "footer.privacy": "隐私",
    "footer.security": "安全",
    "footer.cookies": "Cookie",
    "footer.legal": "法律",
    "footer.guidelines": "社区协作指南",
    "footer.about": "关于我们",
    "cart.add": "加入购物车",
    "cart.added": "已加入",
    "filters.title": "筛选",
    "filters.wishlist": "愿望单",
    "filters.ratings": "评分",
    "filters.reviews": "评论",
    "filters.genres": "类型",
    "filters.genre.action": "动作",
    "filters.genre.strategy": "策略",
    "filters.genre.rpg": "RPG",
    "filters.genre.shooter": "射击",
    "filters.genre.adventure": "冒险",
    "filters.genre.puzzle": "解谜",
    "filters.genre.racing": "竞速",
    "filters.genre.sports": "体育",
    "grid.noReviews.title": "还没有评论哦！",
    "grid.noReviews.subtitle": "你可以很快成为第一个。",
    "legacyGamePage.about": "关于",
    "legacyGamePage.none": "暂无",
    "legacyGamePage.website": "官网",
    "legacyGamePage.released": "发行时间",
    "legacyGamePage.platforms": "平台",
    "legacyGamePage.mainGenre": "主要类型",
    "legacyGamePage.developers": "开发商",
    "legacyGamePage.publishers": "发行商",
    "legacyGamePage.hide": "收起",
    "legacyGamePage.more": "更多",
    "legacyGamePage.notAvailable": "暂不可用",
    "backTop.aria": "回到顶部",
    "aria.menu": "菜单",
    "aria.back": "返回",
    "aria.extend": "展开",
    "aria.like": "点赞",
    "aria.add": "添加",
    "aria.zoomPreview": "点击放大预览",
    "aria.prevScreenshot": "上一张截图",
    "aria.nextScreenshot": "下一张截图",
    "aria.userMenu": "用户菜单",
    "aria.user": "用户",
    "aria.logIn": "登录",
    "aria.prevImage": "上一张图片",
    "aria.nextImage": "下一张图片",
    "aria.closePreview": "关闭预览",
    "aria.closeMenu": "关闭菜单",
    "aria.facebook": "Facebook",
    "aria.discord": "Discord",
    "aria.twitter": "Twitter",
    "aria.youtube": "Youtube",
    "aria.reddit": "Reddit",
    "aria.search": "搜索",
    "aria.notifications": "通知",
    "aria.platform": "平台",
    "aria.android": "Android",
    "aria.preview": "预览",
    "aria.close": "关闭",
    "aria.reply": "回复",
    "aria.prevOne": "上一项",
    "aria.nextOne": "下一项",
    "vote.aria.participate": "参与投票",
    "comment.aria.backToComments": "返回评论区",
    "comment.aria.deleteImage": "删除图片",
    "comment.aria.addImage": "添加图片",
    "topic.aria.quickActions": "帖子快捷操作",
    "topic.aria.viewComments": "查看评论",
    "topic.aria.sidebar": "话题侧边栏",
    "topic.aria.verifiedModerator": "已认证版主",
    "topic.aria.previewImage": "预览图片",
    "topic.aria.removeImage": "移除图片",
    "topic.aria.addImages": "添加图片",
    "topic.aria.removeOption": "删除选项",
    "profile.aria.uploadAvatar": "上传头像",
    "login.aria.countryCode": "国家区号",
    "login.aria.verificationCode": "验证码",
    "login.aria.closeAgreement": "关闭协议",
    "home.search.type.aria": "搜索类型（游戏、话题、合集）",
    "browse.aria.currentFilter": "当前筛选",
    "browse.aria.clearFilters": "清除筛选",
    "postDetail.aria.poll": "帖子投票",
    "slider.aria.prevPicture": "上一张图片",
    "slider.aria.nextPicture": "下一张图片",
    "slider.aria.jumpToPicture": "跳转到该图片",
    "filters.aria.openWishlist": "打开愿望单",
    "filters.aria.sortRatings": "按评分排序",
    "filters.aria.sortReviews": "按评论排序",
    "filters.aria.genreAction": "显示动作类型",
    "filters.aria.genreStrategy": "显示策略类型",
    "filters.aria.genreRpg": "显示 RPG 类型",
    "filters.aria.genreShooter": "显示射击类型",
    "filters.aria.genreAdventure": "显示冒险类型",
    "filters.aria.genrePuzzle": "显示解谜类型",
    "filters.aria.genreRacing": "显示竞速类型",
    "filters.aria.genreSports": "显示体育类型",
    "login.error.network": "网络异常，请检查网络后重试",
    "login.error.sendCodeTimeout": "发送验证码超时了，请重试",
    "login.error.sendCodeException": "发送验证码时请求异常，请稍后再试",
    "login.error.loginTimeout": "登录请求超时了，请重试",
    "login.error.loginException": "登录时请求异常，请稍后再试",
    "request.error.timeout": "请求超时了，请重试",
    "request.error.network": "网络异常，请检查网络后重试",
    "request.error.serverException": "服务器繁忙，请稍后再试",
    "request.error.requestException": "请求失败了，请稍后再试",
    "request.error.sessionExpired": "登录已失效，请重新登录",
    "home.search.noResult": "未找到相关结果",
    "home.search.selectFromList": "找到多个结果，请从列表中选择一个",
    "comment.poll.questionRequired": "请输入投票问题",
    "comment.poll.optionsRequired": "请至少填写两个投票选项",
    "comment.poll.maxSelectedRange": "最多可选需要在 2 到 {count} 之间",
    "comment.poll.addPoll": "添加投票",
    "comment.poll.questionPlaceholder": "请输入投票问题",
    "comment.poll.choiceType": "选择类型",
    "comment.poll.single": "单选",
    "comment.poll.multiple": "多选",
    "comment.poll.maxChoices": "最多可选",
    "comment.poll.optionsLabel": "选项（2–8）",
    "comment.poll.optionPlaceholder": "选项 {index}",
    "comment.poll.addOption": "+ 添加选项"
  },
  "chinese_traditional": {
    "vote.title.default": "投票",
    "vote.meta.participants": "{count} 位小夥伴已參與",
    "vote.meta.maxSelect": "（最多選擇 {max} 項）",
    "vote.meta.loginHint": " · 登錄後可參與投票",
    "vote.meta.clickHint": " · 點我參與",
    "vote.meta.placeholderHint": "登錄後就能參與投票 · 點我參與",
    "vote.voted.hint": "你已經參與過這次投票啦",
    "vote.modal.cancel": "取消",
    "vote.modal.submit": "提交投票",
    "vote.modal.submitting": "提交中...",
    "vote.login.prefix": "請先",
    "vote.login.link": "登錄",
    "vote.login.suffix": "",
    "vote.error.selectOne": "請至少選擇一項",
    "vote.error.singleOnly": "單選投票僅允許選擇一項",
    "vote.error.invalidData": "投票信息有點異常，刷新後再試試吧",
    "vote.error.submit": "提交失敗了，稍後再試試",
    "comment.error.maxImages": "最多上傳 9 張圖片哦",
    "comment.error.uploadImages": "圖片上傳失敗了，再試一次吧",
    "comment.error.empty": "寫點內容再發吧",
    "comment.loading": "加載中...",
    "comment.reply.action": "回覆",
    "comment.replies.viewMore": "查看更多",
    "comment.replies.load": "加載回覆",
    "comment.submit.submitting": "提交中...",
    "comment.submit.reply": "提交回復",
    "comment.submit.comment": "提交",
    "login.title": "歡迎回來",
    "login.subtitle": "繼續登錄",
    "login.tab.phone": "手機",
    "login.tab.email": "郵箱",
    "login.button.login": "登錄",
    "login.divider.orContinue": "或使用以下方式繼續",
    "login.button.vk": "使用 VK 登錄",
    "game.button.download": "下載",
    "game.button.reserve": "取得",
    "game.desc.more": "更多",
    "game.desc.less": "收起",
    "game.ratings.title": "評分與評論",
    "game.right.related": "相關遊戲",
    "game.right.about": "關於遊戲",
    "game.login.prefix": "請先",
    "game.login.link": "登錄",
    "game.login.suffix": "",
    "comment.error.submit": "發佈評論失敗了",
    "comment.error.submitRetry": "發佈評論失敗了，稍後再試試",
    "comment.error.cancelLike": "取消點贊失敗了",
    "comment.error.like": "點贊失敗了",
    "comment.error.toggleLike": "操作失敗了，再試試吧",
    "comment.detail.title": "評論詳情",
    "comment.header.writeReview": "+ 寫條評論",
    "comment.list.title": "評論（{count}）",
    "comment.tab.hot": "熱門",
    "comment.tab.latest": "最新",
    "comment.replies.title": "回覆（{count}）",
    "comment.replies.empty": "來做第一個回覆的人吧",
    "comment.list.empty": "還沒有評論，快來搶沙發",
    "comment.modal.replyTitle": "回覆 @{username}",
    "comment.modal.replyPrefix": "回覆 @",
    "comment.modal.writeTitle": "寫條評論",
    "comment.modal.ratingTitle": "評分（可選）",
    "comment.editor.replyPlaceholder": "回覆 @{username}...",
    "comment.editor.placeholder": "分享一下你的想法吧...",
    "comment.media.uploadHint": "點這裡添加圖片",
    "login.warn.phoneRequired": "先填寫手機號吧",
    "login.warn.emailRequired": "先填寫郵箱吧",
    "login.warn.getCodeFirst": "先獲取驗證碼哦",
    "login.warn.codeRequired": "請輸入驗證碼",
    "login.warn.vkNotConfigured": "VK 還沒配置好，請先在 .env 裡設置 REACT_APP_VK_APP_ID",
    "login.success.codeSent": "驗證碼已發送，注意查收",
    "login.success.login": "登錄成功，歡迎回來",
    "login.confirm.register": "未找到該手機/郵箱賬號，是否註冊新賬號？",
    "login.confirm.restore": "該賬號已註銷，是否恢復並繼續登錄？",
    "login.confirm.title.register": "註冊賬號",
    "login.confirm.title.restore": "恢復賬號",
    "login.confirm.yes": "確認",
    "login.confirm.cancel": "取消",
    "login.error.sendCode": "驗證碼發送失敗了，稍後再試試",
    "login.error.login": "登錄失敗了，稍後再試試",
    "login.info.loadingAgreement": "協議內容加載中，請稍等",
    "login.warn.agreementMissing": "暫時沒有可用的協議內容",
    "login.label.phone": "手機號",
    "login.label.email": "郵箱",
    "login.placeholder.phone": "請輸入手機號",
    "login.placeholder.email": "請輸入郵箱",
    "login.placeholder.captcha": "請輸入驗證碼",
    "login.button.sending": "發送中...",
    "login.button.getCaptcha": "獲取驗證碼",
    "login.agreement.prefix": "登錄即表示你同意我們的",
    "login.agreement.user": "用戶協議",
    "login.agreement.and": " 和 ",
    "login.agreement.privacy": "隱私協議",
    "login.button.signingIn": "登錄中...",
    "game.detail.title": "遊戲詳情",
    "game.ratings.count": "{count} 條評分",
    "game.bottom.tip": "先看到這裡啦，去發現下一款好遊戲吧",
    "game.search.placeholder": "搜遊戲、話題、合集",
    "game.menu.editProfile": "編輯個人資料",
    "game.menu.logout": "退出登錄",
    "game.about.provider": "廠商",
    "game.about.followers": "關注數",
    "game.about.downloads": "下載量",
    "game.about.releaseDate": "發佈時間",
    "game.app.comingSoon": "App 正在努力開發中，敬請期待",
    "game.qr.title": "下載 App",
    "game.qr.subtitle": "發現值得玩的好遊戲",
    "game.modal.scan": "掃碼即可下載",
    "game.modal.downloadTitle": "下載",
    "game.modal.verified": "由 Gamee 官方認證",
    "collection.loading": "加載中...",
    "collection.back": "返回合集",
    "collection.title.default": "合集詳情",
    "collection.hero.subtitle": "合集 · {count} 款遊戲",
    "collection.hero.description.default": "經典奇幻 RPG 系列合集，包含多個正傳與衍生作品，跨平臺都能玩。",
    "collection.stat.comments": "評論數",
    "collection.stat.followers": "關注數",
    "collection.stat.releaseTime": "發佈時間",
    "collection.games.title": "合集內遊戲（{count}）",
    "collection.games.expand": "展開遊戲列表",
    "collection.games.collapse": "收起遊戲列表",
    "collection.games.downloads": "{count} 次下載",
    "collection.games.intro.default": "快來一起玩吧",
    "profile.error.fetch": "獲取個人信息失敗了",
    "profile.warn.selectImage": "請選擇圖片文件",
    "profile.success.avatarUpdated": "頭像更新成功",
    "profile.error.avatarLink": "頭像鏈接獲取失敗",
    "profile.error.avatarMissingId": "上傳成功了，但沒拿到附件 ID",
    "profile.error.avatarUpload": "頭像上傳失敗了",
    "profile.success.save": "保存成功",
    "profile.error.save": "保存失敗了",
    "profile.title": "編輯資料",
    "profile.subtitle": "更新一下你的個人信息",
    "profile.loading": "加載中...",
    "profile.avatar.uploading": "上傳中...",
    "profile.avatar.change": "更換頭像",
    "profile.avatar.clickUpload": "點我上傳",
    "profile.label.nickname": "暱稱",
    "profile.label.country": "國家/地區",
    "profile.label.introduction": "個人簡介",
    "profile.button.cancel": "取消",
    "profile.button.save": "保存",
    "profile.button.saving": "保存中...",
    "profile.country.select": "請選擇國家/地區",
    "vk.error.auth": "VK 授權失敗了",
    "vk.error.noCode": "沒有拿到授權碼",
    "vk.success.login": "VK 登錄成功",
    "vk.confirm.register": "未找到 VK 賬號，是否註冊新賬號？",
    "vk.confirm.restore": "該 VK 賬號已註銷，是否恢復並繼續登錄？",
    "vk.error.invalidResponse": "登錄返回結果異常",
    "vk.error.login": "VK 登錄失敗了",
    "vk.status.loading": "正在完成 VK 登錄...",
    "vk.status.success": "登錄成功，馬上跳轉...",
    "vk.status.error": "登錄失敗，正在返回首頁...",
    "common.loading": "加載中...",
    "sidebar.language": "語言",
    "sidebar.appearance": "外觀",
    "sidebar.theme.dark": "深色主題",
    "sidebar.theme.light": "淺色主題",
    "sidebar.loginCta": "免費加入或登錄",
    "sidebar.footer.links": "開發者 · 法律 · 條款 · 隱私",
    "sidebar.footer.slogan": "來一起玩。",
    "home.search.placeholder": "搜遊戲、話題、合集",
    "home.search.mobilePlaceholder": "搜索",
    "home.search.searching": "正在搜索...",
    "home.search.action": "搜索",
    "home.app.comingSoon": "App 正在火速開發中，敬請期待",
    "home.downloadApp": "下載 App",
    "home.downloadApp.loading": "下載中...",
    "home.download.failed": "獲取下載連結失敗，請稍後重試",
    "home.download.title": "正在下載 Gamee App",
    "home.download.preparing": "正在準備下載...",
    "home.download.downloading": "正在下載...",
    "home.download.downloadingPercent": "正在下載 {percent}%...",
    "home.download.hint": "請稍候，檔案將保存為 {filename}",
    "home.download.minimize": "最小化",
    "home.download.expand": "查看下載進度",
    "home.menu.editProfile": "編輯個人信息",
    "home.menu.logout": "退出登錄",
    "home.loginCta": "免費加入或登錄",
    "home.notifications.title": "消息中心",
    "home.notifications.system": "系統通知",
    "home.notifications.empty": "暫無消息",
    "home.featured.title": "本週精選",
    "home.category.default": "分類",
    "home.category.description": "來 Gamee 逛逛熱門 {title} 遊戲，Android可能玩。免費、安全、可看評價，還能分享你的體驗。",
    "home.trending.title": "大家都在玩",
    "home.trending.discussion": "來 Gamee 一起聊聊",
    "home.trending.defaultTopComment": "正在 Android 熱門榜上升中。",
    "home.trending.loadError": "熱門遊戲加載失敗，請檢查網絡後重試。",
    "home.trending.empty": "這裡暫時沒有可展示的遊戲。",
    "home.trending.noMore": "沒有更多遊戲了",
    "home.mobile.trending": "熱榜",
    "home.search.type.games": "遊戲",
    "home.search.type.topics": "話題",
    "home.search.type.collections": "合集",
    "home.rank.top": "TOP",
    "topic.error.removeLike": "取消點贊失敗",
    "topic.error.like": "點贊失敗",
    "topic.error.action": "操作失敗，請重試",
    "topic.warn.maxImages": "最多可上傳 9 張圖片",
    "topic.error.imageUpload": "圖片上傳失敗",
    "topic.warn.titleRequired": "請輸入標題",
    "topic.warn.contentOrImage": "請輸入內容或至少添加一張圖片",
    "topic.warn.waitImages": "請等待圖片上傳完成",
    "topic.warn.pollQuestion": "請輸入投票問題",
    "topic.warn.pollOptions": "請至少填寫兩個投票選項",
    "topic.error.createPoll": "創建投票失敗",
    "topic.error.pollNoId": "投票已創建，但服務端未返回投票 ID",
    "topic.success.postCreated": "發佈成功，大家都能看到啦",
    "topic.error.createPostRetry": "發佈帖子失敗，請稍後重試",
    "topic.warn.deleteOwnOnly": "只能刪除自己的帖子",
    "topic.success.postDeleted": "帖子已刪除",
    "topic.error.deletePostRetry": "刪除帖子失敗，請稍後重試",
    "topic.back": "返回話題",
    "topic.hero.collapse": "收起",
    "topic.hero.expand": "展開",
    "topic.hero.replies": "{count} 條回覆 · 進入討論串",
    "topic.hero.enterDiscussion": "進入討論",
    "topic.posts.title": "帖子列表",
    "topic.posts.count": "{count} 篇帖子",
    "topic.posts.create": "發帖",
    "topic.posts.loading": "正在加載帖子...",
    "topic.posts.empty": "還沒有帖子，來發第一條吧",
    "topic.posts.deleting": "刪除中...",
    "topic.posts.delete": "刪除",
    "topic.posts.loadingMore": "正在加載更多帖子...",
    "topic.posts.scrollLoadMore": "滾動到底部加載更多",
    "topic.posts.noMore": "沒有更多帖子了",
    "topic.modal.createTitle": "發佈帖子",
    "topic.modal.titlePlaceholder": "請輸入帖子標題",
    "topic.modal.contentPlaceholder": "請輸入帖子內容（如添加圖片可選填）",
    "topic.modal.uploading": "上傳中…",
    "topic.modal.addImages": "添加圖片（最多9張，每張不超過2MB）",
    "topic.modal.addPoll": "添加投票",
    "topic.modal.cancel": "取消",
    "topic.modal.publishing": "發佈中...",
    "topic.modal.publish": "立即發佈",
    "topic.delete.title": "刪除帖子",
    "topic.delete.confirm": "確定要刪除該帖子嗎？此操作不可撤銷。",
    "topic.side.moderator": "版主",
    "topic.side.moderatorEmpty": "暫無版主信息",
    "topic.side.activeUsers": "活躍用戶",
    "topic.side.activeUsersEmpty": "暫無活躍用戶",
    "topic.poll.single": "單選",
    "topic.poll.multiple": "多選",
    "topic.poll.choiceType": "選擇類型",
    "topic.poll.maxChoices": "最多可選",
    "topic.poll.optionsLabel": "選項（2–8）",
    "topic.poll.optionPlaceholder": "選項 {index}",
    "topic.poll.addOption": "+ 添加選項",
    "topics.title": "話題",
    "topics.subtitle": "看看大家最近在聊什麼",
    "topics.voted": "已有 {count} 人投票",
    "topics.empty": "暫無話題",
    "collections.title": "合集",
    "collections.subtitle": "發現更多有意思的精選合集",
    "collections.noMore": "沒有更多合集了",
    "navbar.loginCta": "免費加入 / 登錄",
    "postDetail.back": "返回",
    "postDetail.loading": "加載中...",
    "postDetail.notFound": "帖子不存在或已被刪除",
    "postDetail.untitled": "無標題帖子",
    "postDetail.unknownUser": "未知用戶",
    "postDetail.unknownTime": "未知時間",
    "postDetail.likes": "{count} 個贊",
    "postDetail.comments": "{count} 條評論",
    "postDetail.noDescription": "暫無描述",
    "notFound.title": "{path} 暫不可用！",
    "notFound.message": "你訪問的頁面當前不可用。我們將很快帶你回到瀏覽頁。如果你覺得這是個錯誤，",
    "notFound.contact": "聯繫我們！",
    "browse.title": "趨勢與話題",
    "browse.subtitle": "基於玩家數量和評分",
    "browse.filterBy": "篩選：",
    "browse.clearFilter": "清除篩選",
    "footer.privacy": "隱私",
    "footer.security": "安全",
    "footer.cookies": "Cookie",
    "footer.legal": "法律",
    "footer.guidelines": "社區協作指南",
    "footer.about": "關於我們",
    "cart.add": "加入購物車",
    "cart.added": "已加入",
    "filters.title": "篩選",
    "filters.wishlist": "願望單",
    "filters.ratings": "評分",
    "filters.reviews": "評論",
    "filters.genres": "類型",
    "filters.genre.action": "動作",
    "filters.genre.strategy": "策略",
    "filters.genre.rpg": "RPG",
    "filters.genre.shooter": "射擊",
    "filters.genre.adventure": "冒險",
    "filters.genre.puzzle": "解謎",
    "filters.genre.racing": "競速",
    "filters.genre.sports": "體育",
    "grid.noReviews.title": "還沒有評論哦！",
    "grid.noReviews.subtitle": "你可以很快成為第一個。",
    "legacyGamePage.about": "關於",
    "legacyGamePage.none": "暫無",
    "legacyGamePage.website": "官網",
    "legacyGamePage.released": "發行時間",
    "legacyGamePage.platforms": "平臺",
    "legacyGamePage.mainGenre": "主要類型",
    "legacyGamePage.developers": "開發商",
    "legacyGamePage.publishers": "發行商",
    "legacyGamePage.hide": "收起",
    "legacyGamePage.more": "更多",
    "legacyGamePage.notAvailable": "暫不可用",
    "backTop.aria": "回到頂部",
    "aria.menu": "菜單",
    "aria.back": "返回",
    "aria.extend": "展開",
    "aria.like": "點贊",
    "aria.add": "添加",
    "aria.zoomPreview": "點擊放大預覽",
    "aria.prevScreenshot": "上一張截圖",
    "aria.nextScreenshot": "下一張截圖",
    "aria.userMenu": "用戶菜單",
    "aria.user": "用戶",
    "aria.logIn": "登錄",
    "aria.prevImage": "上一張圖片",
    "aria.nextImage": "下一張圖片",
    "aria.closePreview": "關閉預覽",
    "aria.closeMenu": "關閉菜單",
    "aria.facebook": "Facebook",
    "aria.discord": "Discord",
    "aria.twitter": "Twitter",
    "aria.youtube": "Youtube",
    "aria.reddit": "Reddit",
    "aria.search": "搜索",
    "aria.notifications": "通知",
    "aria.platform": "平臺",
    "aria.android": "Android",
    "aria.preview": "預覽",
    "aria.close": "關閉",
    "aria.reply": "回覆",
    "aria.prevOne": "上一項",
    "aria.nextOne": "下一項",
    "vote.aria.participate": "參與投票",
    "comment.aria.backToComments": "返回評論區",
    "comment.aria.deleteImage": "刪除圖片",
    "comment.aria.addImage": "添加圖片",
    "topic.aria.quickActions": "帖子快捷操作",
    "topic.aria.viewComments": "查看評論",
    "topic.aria.sidebar": "話題側邊欄",
    "topic.aria.verifiedModerator": "已認證版主",
    "topic.aria.previewImage": "預覽圖片",
    "topic.aria.removeImage": "移除圖片",
    "topic.aria.addImages": "添加圖片",
    "topic.aria.removeOption": "刪除選項",
    "profile.aria.uploadAvatar": "上傳頭像",
    "login.aria.countryCode": "國家區號",
    "login.aria.verificationCode": "驗證碼",
    "login.aria.closeAgreement": "關閉協議",
    "home.search.type.aria": "搜索類型（遊戲、話題、合集）",
    "browse.aria.currentFilter": "當前篩選",
    "browse.aria.clearFilters": "清除篩選",
    "postDetail.aria.poll": "帖子投票",
    "slider.aria.prevPicture": "上一張圖片",
    "slider.aria.nextPicture": "下一張圖片",
    "slider.aria.jumpToPicture": "跳轉到該圖片",
    "filters.aria.openWishlist": "打開願望單",
    "filters.aria.sortRatings": "按評分排序",
    "filters.aria.sortReviews": "按評論排序",
    "filters.aria.genreAction": "顯示動作類型",
    "filters.aria.genreStrategy": "顯示策略類型",
    "filters.aria.genreRpg": "顯示 RPG 類型",
    "filters.aria.genreShooter": "顯示射擊類型",
    "filters.aria.genreAdventure": "顯示冒險類型",
    "filters.aria.genrePuzzle": "顯示解謎類型",
    "filters.aria.genreRacing": "顯示競速類型",
    "filters.aria.genreSports": "顯示體育類型",
    "login.error.network": "網絡異常，請檢查網絡後重試",
    "login.error.sendCodeTimeout": "發送驗證碼超時了，請重試",
    "login.error.sendCodeException": "發送驗證碼時請求異常，請稍後再試",
    "login.error.loginTimeout": "登錄請求超時了，請重試",
    "login.error.loginException": "登錄時請求異常，請稍後再試",
    "request.error.timeout": "請求超時了，請重試",
    "request.error.network": "網絡異常，請檢查網絡後重試",
    "request.error.serverException": "服務器繁忙，請稍後再試",
    "request.error.requestException": "請求失敗了，請稍後再試",
    "request.error.sessionExpired": "登錄已失效，請重新登錄",
    "home.search.noResult": "未找到相關結果",
    "home.search.selectFromList": "找到多個結果，請從列表中選擇一個",
    "comment.poll.questionRequired": "請輸入投票問題",
    "comment.poll.optionsRequired": "請至少填寫兩個投票選項",
    "comment.poll.maxSelectedRange": "最多可選需要在 2 到 {count} 之間",
    "comment.poll.addPoll": "添加投票",
    "comment.poll.questionPlaceholder": "請輸入投票問題",
    "comment.poll.choiceType": "選擇類型",
    "comment.poll.single": "單選",
    "comment.poll.multiple": "多選",
    "comment.poll.maxChoices": "最多可選",
    "comment.poll.optionsLabel": "選項（2–8）",
    "comment.poll.optionPlaceholder": "選項 {index}",
    "comment.poll.addOption": "+ 添加選項",
  }
};
